// Backend content types "PLM - Week 1" through "PLM - Week 6".
// This array is the single source of truth: it drives both the PLM homepage
// tiles and the week routes, so a week cannot exist in one place and not the other.
//
// Weeks run in rainbow order: red, orange, yellow, green, blue, purple.
// `color` is the tile fill, `borderColor` its darker edge (the same hue at 75%
// brightness), and `fontColor` the label.
//
// Week 3 is the exception to white lettering. No color light enough to read as
// yellow can carry white text — a true yellow puts it near 1.2:1 — so the
// yellow tile takes near-black text instead, at 11.5:1. Darkening the fill
// until white worked would have turned it into a mustard brown. Every other
// fill clears 3.8:1 against white, above the 3:1 minimum for large text.
const PLM_WEEKS = [
  { week: 1, title: "Week 1", path: "/plm-week-1", key: "plm-week-1", resourceType: 15, color: "#C62828", borderColor: "#941E1E", fontColor: "#FFFFFF" },
  { week: 2, title: "Week 2", path: "/plm-week-2", key: "plm-week-2", resourceType: 16, color: "#E65100", borderColor: "#AC3D00", fontColor: "#FFFFFF" },
  { week: 3, title: "Week 3", path: "/plm-week-3", key: "plm-week-3", resourceType: 17, color: "#FFD600", borderColor: "#BFA100", fontColor: "#212121" },
  { week: 4, title: "Week 4", path: "/plm-week-4", key: "plm-week-4", resourceType: 18, color: "#2E7D32", borderColor: "#225E26", fontColor: "#FFFFFF" },
  { week: 5, title: "Week 5", path: "/plm-week-5", key: "plm-week-5", resourceType: 19, color: "#1565C0", borderColor: "#104C90", fontColor: "#FFFFFF" },
  { week: 6, title: "Week 6", path: "/plm-week-6", key: "plm-week-6", resourceType: 20, color: "#6A1B9A", borderColor: "#501474", fontColor: "#FFFFFF" },
];

// Tile text color for the non-week tiles.
const PLM_TILE_FONT_COLOR = "#FFFFFF";

// "Just for Fun" is not a week, so it gets a hue outside the week set.
const PLM_FUN_COLOR = "#BE185D";
const PLM_FUN_BORDER_COLOR = "#8E1246";

export default PLM_WEEKS;
export { PLM_TILE_FONT_COLOR, PLM_FUN_COLOR, PLM_FUN_BORDER_COLOR };
